import PersonInfo from "./PersonInfo";
export default PersonInfo;
